import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'vanishingTableSelection',
  components: {
    DataGridComp: require('./datagrid.vue').default,
  },
  props: {
    parent: {
      type: Object,
      required: true
    },
    dataSourceFun: {
      type: Function,
      required: true
    },
    dataSource: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    selection: {
      type: Function
    },
    label: {
      type: String,
      default: ''
    },
    displayField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    parentModel: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      showDialog: false,
      selectedObj: null,
      displayedValue: '',
      propertiesTonwnship: [],
      selectedTownship: ''
    }
  },
  created() {
   
  },
  watch: {

  },
  methods: {
    
    searchCustomers() {
      this.parent.getCustomers(this.billGroupSelectedId);
    },
    pageChange(pInfo) {
      if (this.config.pageOptions.page == pInfo.pageNumber && this.config.pageOptions.pageSize == pInfo.pageSize)
        return;

      this.config.pageOptions.page = pInfo.pageNumber;
      this.config.pageOptions.pageSize = pInfo.pageSize;

      this.dataSourceFun(this.config.pageOptions);
    },
    rowSelected(info) {
      this.selectedObj = info.data;
      this.fillParentModel();
      this.showDialog = false;

    },
    
    fillParentModel() {
      if (this.parent == '')
        return;
      this.parent.addProperty(this.selectedObj);
      
    },
    


  }
}
